import { PALETTE } from "./palette";

// SVG gradient defs that give chart shapes a translucent "liquid glass" fill.
export const glassFill = (i, horizontal = false) =>
  `url(#glassg-${horizontal ? "h" : "v"}-${i % PALETTE.length})`;

export const GLASS_STROKE = "rgba(255,255,255,0.75)";

export const GlassDefs = () => (
  <defs>
    {PALETTE.map((c, i) => (
      <linearGradient key={`v-${i}`} id={`glassg-v-${i}`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.6" />
        <stop offset="28%" stopColor={c} stopOpacity="0.62" />
        <stop offset="100%" stopColor={c} stopOpacity="0.95" />
      </linearGradient>
    ))}
    {PALETTE.map((c, i) => (
      <linearGradient key={`h-${i}`} id={`glassg-h-${i}`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.6" />
        <stop offset="28%" stopColor={c} stopOpacity="0.62" />
        <stop offset="100%" stopColor={c} stopOpacity="0.95" />
      </linearGradient>
    ))}
    {PALETTE.map((c, i) => (
      <linearGradient key={`a-${i}`} id={`glassg-a-${i}`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor={c} stopOpacity="0.4" />
        <stop offset="100%" stopColor={c} stopOpacity="0.03" />
      </linearGradient>
    ))}
  </defs>
);
